module.exports = __webpack_public_path__ + "static/media/5DPO22.877debb6.jpg";